import { Form, Col, Upload } from "antd";
import Select from "react-select";
import { UploadOutlined } from "@ant-design/icons";

const PaymentDetailsSection = ({
  formData,
  setFormData,
  errors,
  bankOptions,
  banksLoading,
}) => {
  const selectStyles = (errorFieldName) => ({
    control: (provided) => ({
      ...provided,
      borderColor: errors[errorFieldName] ? "#dc3545" : provided.borderColor,
      boxShadow: errors[errorFieldName]
        ? "0 0 0 0.2rem rgba(220, 53, 69, 0.25)"
        : provided.boxShadow,
      minHeight: 22,
      height: 33,
    }),
  });

  //   const bankOptions = [
  //   { value: "sbi", label: "State Bank of India" },
  //   { value: "hdfc", label: "HDFC Bank" },
  //   { value: "icici", label: "ICICI Bank" },
  //   { value: "axis", label: "Axis Bank" },
  // ];

  // console.log("bank options", bankOptions);

  const paymentStatusOptions = [
    { value: "manual", label: "Manual payment" },
    { value: "link", label: "Send online payment link" },
  ];

  const paymentModeOptions = [
    { value: "upi", label: "UPI" },
    { value: "bank_transfer", label: "Bank Transfer" },
    { value: "cash", label: "Cash" },
  ];

  const isManual = formData.payment_status === "manual";
  const isBankTransfer = formData.payment_mode === "bank_transfer";
  const isUPI = formData.payment_mode === "upi";
  const isCash = isManual && formData.payment_mode === "cash";

  return (
    formData.customer_type === "1" && (
      <>
        {/* Payment Status */}
        <Col xs={24} sm={12}>
          <Form.Item
            label="Payment Status"
            validateStatus={errors.payment_status ? "error" : ""}
            help={errors.payment_status}
          >
            <Select
              placeholder="Select Payment Status"
              options={paymentStatusOptions}
              value={
                paymentStatusOptions.find(
                  (opt) => opt.value === formData.payment_status,
                ) || null
              }
              onChange={(opt) => {
                setFormData((prev) => ({
                  ...prev,
                  payment_status: opt?.value || "",
                  payment_mode: "",
                  utr_no: "",
                  payment_attachment: null,
                }));
              }}
              styles={selectStyles("payment_status")}
            />
          </Form.Item>
        </Col>

        {/* Payment Mode */}
        {isManual && (
          <Col xs={24} sm={12}>
            <Form.Item
              label="Payment Mode"
              validateStatus={errors.payment_mode ? "error" : ""}
              help={errors.payment_mode}
            >
              <Select
                placeholder="Select Payment Mode"
                options={paymentModeOptions}
                value={
                  paymentModeOptions.find(
                    (opt) => opt.value === formData.payment_mode,
                  ) || null
                }
                onChange={(opt) =>
                  setFormData((prev) => ({
                    ...prev,
                    payment_mode: opt?.value || "",
                    utr_no: "",
                    payment_attachment: null,
                  }))
                }
                styles={selectStyles("payment_mode")}
              />
            </Form.Item>
          </Col>
        )}

        {isManual && (
          <Col xs={24} sm={12}>
            <Form.Item
              label="Total Amount Received"
              required
              validateStatus={errors.amount_received ? "error" : ""}
              help={errors.amount_received}
            >
              <input
                type="number"
                className="form-control"
                placeholder="Enter Total Amount Received"
                value={formData.amount_received || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    amount_received: e.target.value,
                  }))
                }
                min={0}
                // step defaults to 1 on type="number", which marks a paise value
                // like 17405.50 as :invalid and can block native form submission
                step="0.01"
              />
            </Form.Item>
          </Col>
        )}

        {/* Bank Dropdown (Only Bank Transfer) */}
        {isManual && isBankTransfer && (
          <Col xs={24} sm={12}>
            <Form.Item
              label="Select Bank"
              required
              validateStatus={errors.bank_name ? "error" : ""}
              help={errors.bank_name}
            >
              <Select
                placeholder={banksLoading ? "Loading banks..." : "Select Bank"}
                options={bankOptions}
                isLoading={banksLoading}
                value={
                  bankOptions.find((opt) => opt.value === formData.bank_name) ||
                  null
                }
                onChange={(option) =>
                  // handleInputChange({ value: option?.value }, "bank_name")
                  setFormData((prev) => ({
                    ...prev,
                    bank_name: option?.value || "",
                  }))
                }
                styles={selectStyles("bank_name")}
              />
            </Form.Item>
          </Col>
        )}

        {isManual && (isUPI || isBankTransfer) && (
          <Col xs={24} sm={12}>
            <Form.Item
              label="UTR No"
              required
              validateStatus={errors.utr_no ? "error" : ""}
              help={errors.utr_no}
            >
              <input
                type="text"
                className="form-control"
                placeholder="Enter UTR Number (12–22 characters)"
                value={formData.utr_no || ""}
                maxLength={22}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                  setFormData((prev) => ({ ...prev, utr_no: val }));
                }}
              />
              {/* Live character counter */}
              <div
                style={{
                  fontSize: "11px",
                  color: formData.utr_no?.length >= 12 ? "#16a34a" : "#9ca3af",
                  marginTop: "4px",
                  textAlign: "right",
                }}
              >
                {formData.utr_no?.length || 0} / 22 characters
                {formData.utr_no?.length >= 12 && (
                  <span style={{ marginLeft: "6px" }}>✓ Valid length</span>
                )}
              </div>
            </Form.Item>
          </Col>
        )}

        {/* Attachment (UPI / Bank / Cash) */}
        {(isManual || isCash) && (
          <Col xs={24} sm={12}>
            <Form.Item
              label="Upload Attachment"
              required
              validateStatus={errors.payment_attachment ? "error" : ""}
              help={errors.payment_attachment}
            >
              <Upload
                beforeUpload={() => false}
                maxCount={1}
                onChange={({ file }) =>
                  setFormData((prev) => ({
                    ...prev,
                    payment_attachment: file,
                  }))
                }
              >
                <button
                  type="button"
                  className="btn btn-outline-secondary btn-sm"
                >
                  <UploadOutlined /> Upload File
                </button>
              </Upload>
              {/* Editing an order: the proof already on it stays unless a new file is chosen. */}
              {formData.payment_proof_url && !formData.payment_attachment && (
                <div style={{ fontSize: 12, marginTop: 6 }}>
                  Current file:{" "}
                  <a href={formData.payment_proof_url} target="_blank" rel="noopener noreferrer">
                    View uploaded proof
                  </a>
                </div>
              )}
            </Form.Item>
          </Col>
        )}
      </>
    )
  );
};

export default PaymentDetailsSection;
